import { RouteObject } from 'react-router-dom';
import { PayBillsLanding } from './components/quick-services/pay-bills/Landing';
import NSCLanding from './components/quick-services/nsc/Landing';
import { InfocenterLanding } from './components/quick-services/info-center/Landing';
import ApplicationStatus from './components/quick-services/nsc/application-status/ApplicationStatus';
import NewConnectionLanding from './components/quick-services/nsc/create/create';
import NSCSuccess from './components/quick-services/nsc/create/success';
import { ServiceRequestLanding } from './components/quick-services/service-request/Landing';

export const guestPortalRoutes: RouteObject[] = [
  {
    path: '/guest/pay-bill/:tenant?/:utilityName?',
    element: <PayBillsLanding />
  },
  {
    path: '/guest/nsc/:tenant?/:utilityName?',
    element: <NSCLanding />
  },
  {
    path: '/guest/info-center/:tenant?/:utilityName?',
    element: <InfocenterLanding />
  },
  {
    path: '/guest/application-status/:tenant?/:utilityName?',
    element: <ApplicationStatus />
  },
  {
    path: '/guest/nsc-create/:tenant?/:utilityName?',
    element: <NewConnectionLanding />
  },
  {
    path: '/guest/nsc-create-success/:tenant?/:utilityName?',
    element: <NSCSuccess />
  },
  {
    path: '/guest/service-request/:tenant?/:utilityName?',
    element: <ServiceRequestLanding />
  }
];
